export const incomeProductSchema = ({list, Status}) => {
    const {
        items: tagList,
        status: tagListStatus,
    } = list.tag;

    return (
        {
            name: {
                type: 'text',
                label: 'Name',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Name is required';
                    return null;
                },
            },
            stock: {
                type: 'text',
                label: 'Stock',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (!String(value).trim()) return 'Stock is required';
                    return null;
                },
            },
            image: {
                type: "file",
                label: 'Image',
                columns: {md: 12, lg: 6},
            },
            status: {
                type: 'select',
                label: 'Status',
                enums: true,
                options: Status,
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    return null;
                },
            },
            price: {
                type: 'text',
                label: 'Price',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    return null;
                },
            },
            sellPrice: {
                type: 'text',
                label: 'Sell Price',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (!String(value).trim()) return 'Sell Price is required';
                    return null;
                },
            },
            tags: {
                type: 'multiselect',
                label: 'Tags',
                options: tagListStatus === "success" ? tagList : {},
                columns: {md: 12, lg: 6},
                isSearch: true,
                searchPlaceholder: 'Search "Tags"',
                validation: (value) => {
                    if (!Array.isArray(value) || value.length === 0) return 'At least one tag is required';
                    return null;
                },
            },
            description: {
                type: 'textarea',
                label: 'Description',
            },
            availability: {
                type: 'switch',
                label: 'Availability',
                columns: {md: 12, lg: 6},
            },
            additionalDetails: {
                type: 'object',
                properties: {
                    isVeg: {
                        type: 'checkbox',
                        label: 'Is Veg',
                        columns: {md: 12, lg: 6},
                        validation: (value) => {
                            return null;
                        },
                    }
                }
            }
        }
    )
}

export const productReportSchema = () => {
    return (
        {
            startDate: {
                type: 'date',
                label: 'Start Date',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (!value || value.trim() === '') return 'Start date is required';
                    return null;
                },
            },
            endDate: {
                type: 'date',
                label: 'End Date',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (!value || value.trim() === '') return 'End date is required';
                    return null;
                },
            },
        }
    )
}
